export const sanitizeEmail = (email: string) => email.toLocaleLowerCase().trim();
